import { render, staticRenderFns } from "./PainelDocumentoSolicitadoVisualizacao.vue?vue&type=template&id=35d8735c&scoped=true"
import script from "./PainelDocumentoSolicitadoVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelDocumentoSolicitadoVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./PainelDocumentoSolicitadoVisualizacao.vue?vue&type=style&index=0&id=35d8735c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8735c",
  null
  
)

export default component.exports